import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, AddShoppingCart, WatchOutlined, WatchRounded, AccessTime,CalendarToday, CalendarTodayTwoTone } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import { addDays } from "../../utils/addDays.js";
import { NotificationManager } from "react-notifications";
const disableDates = new Date();
const date1=disableDates.getDate();


class BookingScheduleScreenNew extends Component {
    constructor(props) {
        super(props);

        this.state = { 
            update: false, 
            showAlert: false,
            bookingPath: this.props.history.location.state.BookingPath,
            bookingDateEdit: this.props.history.location.state.bookingDateEdit,
            bookingSlotEdit: this.props.history.location.state.bookingSlotEdit,
            originalCalendarDate:'',

            taskDetailsPrev: this.props.history.location.state.taskData,
            // serviceDataPrev: this.props.history.location.state.categoryData.categories
            whichServiceType: 1,
            todayServiceActive: false,
            futureServiceActive: true,
            todayTimeSlots: [{"end": 32399, "label": "06am - 09am", "start": 21600, "status": true}, {"end": 43199, "label": "09am - 12pm", "start": 32400, "status": true}, {"end": 53999, "label": "12pm - 03pm", "start": 43200, "status": true}, {"end": 64799, "label": "03pm - 06pm", "start": 54000, "status": true}, {"end": 75599, "label": "06pm - 09pm", "start": 64800, "status": true}]
            ,
            futureTimeSlots: [{"end": 32399, "label": "06am - 09am", "start": 21600, "status": true}, {"end": 43199, "label": "09am - 12pm", "start": 32400, "status": true}, {"end": 53999, "label": "12pm - 03pm", "start": 43200, "status": true}, {"end": 64799, "label": "03pm - 06pm", "start": 54000, "status": true}, {"end": 75599, "label": "06pm - 09pm", "start": 64800, "status": true}],
            // selectDateError: this.props.history.location.state.BookingPath =='edit' ? false : true,
            selectDateError: false,
            selectFutureDateError: false,
            isTimeslotSelected: false,
            selectedTimeSlotLabel: '',
            timeNew: '',
            // todaysDate: new Date(),
            todaysDate: addDays(new Date, 1),
            bookingFinalPrice: this.props.history.location.state.taskData.price,
            selectTimeslotError: this.props.history.location.state.BookingPath =='edit' ? false : true
        };
    }
    componentDidMount() {
        console.log("bookingPath", this.state.bookingPath);
        console.log("bookingDateEdit", this.state.bookingDateEdit);
        console.log("taskDetailsPrev", this.state.taskDetailsPrev);
        console.log("bookingSlotEdit", this.state.bookingSlotEdit);

        if(this.state.bookingPath == 'edit'){
            this.origialTimeslotForEdit()
        }
    }   

    origialTimeslotForEdit() {
        // let originalTimeSlot = this.state.futureTimeSlots.filter((time)=> {
        //     let upd = time.label === this.state.bookingSlotEdit ? time : ''
        //     console.log("upd", upd);
        //     return upd
        // })
        // console.log('originalTimeSlot', originalTimeSlot);

        //Find index of specific object using findIndex method.    
        let objIndex = this.state.futureTimeSlots.findIndex((obj => obj.label === this.state.bookingSlotEdit));
        console.log('objIndex', objIndex);

        // console.log("Before update: ", this.state.futureTimeSlots[objIndex])

        //Update object's name property.
        // this.state.futureTimeSlots[objIndex].label = false

        // console.log("After update: ", this.state.futureTimeSlots[objIndex])
        this.setState({
            isTimeslotSelected: this.state.futureTimeSlots[objIndex].label
        })

    }

    updateTimeslotForUpdate

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    handleEventClick = (singleEvent) => {
        console.log("Event date");
        console.log(singleEvent);
    //     this.props.history.push({
    //       pathname: `/user/booking/detail/${singleEvent.id}`,
    //       bookingId: singleEvent.id,
    //     });
    };

    handleSelect = (event) => {
        // console.log("start", start);
        // console.log("end", end);
        console.log("CLICK EVENT ", event);
        // const title = window.prompt("New Event name");
        // if (title)
        // //   setEventsData([
        // //     ...eventsData,
        // //     {
        // //       start,
        // //       end,
        // //       title
        // //     }
        // //   ]);
        //   this.setState({
        //     eventData: [
        //         ...this.state.eventData,
        //         {
        //           start,
        //           end,
        //           title
        //         }
        //       ]
        //   })
      };

    addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    minusDays(date, days) {
        var minusResult = new Date(date);
        minusResult.setDate(minusResult.getDate() - days);
        return minusResult;
    }

    updatingTodaysTiminggggg = () => {
        const now = new Date();
        let timeNewwHrs;
                const month = now.getMonth();
                if (month < 2 || month > 10) {
                    // It's outside of DST.
                    timeNewwHrs = showDate(8);
                    console.log("Pacific Time is currently in standard time (UTC-8).");
                } else if (month > 2 && month < 10) {
                    // It's during DST.
                    timeNewwHrs = showDate(7);
                    console.log("Pacific Time is currently in daylight saving time (UTC-7).");
                } else {
                    const previousSunday = now.getDate() - now.getDay();
                    const transitionStart = new Date(now.getFullYear(), 2, previousSunday, 2, 0, 0);
                    const transitionEnd = new Date(now.getFullYear(), 10, previousSunday, 2, 0, 0);
                    
                    if (now >= transitionStart && now < transitionEnd) {
                        console.log("Pacific Time is currently in daylight saving time (UTC-7).");
                        timeNewwHrs = showDate(7);
                    } else {
                        console.log("Pacific Time is currently in standard time (UTC-8).");
                        timeNewwHrs = showDate(8);
                    }
              }
    
        function showDate(time){
          const now = new Date();
          const utcMinus7 = now.getTime() - (time * 60 * 60 * 1000);
          const date = new Date(utcMinus7).toISOString().split('T')[0];
          const [hours, minutes, seconds] = new Date(utcMinus7).toISOString().split('T')[1].slice(0,-5).split(':');
        //   console.log("date",date); //2023-04-18
        //   console.log("hours",hours);
        //   console.log("minutes",minutes);
        //   console.log("seconds",seconds);
          return Number(hours)
        }
          
          if(timeNewwHrs < 6){
              const newTimeSlots = [...this.state.todayTimeSlots];
              newTimeSlots[0].status = true;
              newTimeSlots[1].status = true;
              newTimeSlots[2].status = true;
              newTimeSlots[3].status = true;
              newTimeSlots[4].status = true;
              // this.setState({
              //   selectFutureDateError: true
              // })
              this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false });
          } else if (timeNewwHrs >= 6 && timeNewwHrs < 9){
              const newTimeSlots = [...this.state.todayTimeSlots];
              newTimeSlots[0].status = false;
              newTimeSlots[1].status = true;
              newTimeSlots[2].status = true;
              newTimeSlots[3].status = true;
              newTimeSlots[4].status = true;
              this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false  });
          } else if (timeNewwHrs >= 9 && timeNewwHrs < 12){
            const newTimeSlots = [...this.state.todayTimeSlots];
            newTimeSlots[0].status = false;
            newTimeSlots[1].status = false;
            newTimeSlots[2].status = true;
            newTimeSlots[3].status = true;
            newTimeSlots[4].status = true;
            this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false  });
          } else if (timeNewwHrs >= 12 && timeNewwHrs < 15){
            const newTimeSlots = [...this.state.todayTimeSlots];
            newTimeSlots[0].status = false;
            newTimeSlots[1].status = false;
            newTimeSlots[2].status = false;
            newTimeSlots[3].status = true;
            newTimeSlots[4].status = true;
            this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false  });
          } else if (timeNewwHrs >= 15 && timeNewwHrs < 18){
            const newTimeSlots = [...this.state.todayTimeSlots];
            newTimeSlots[0].status = false;
            newTimeSlots[1].status = false;
            newTimeSlots[2].status = false;
            newTimeSlots[3].status = false;
            newTimeSlots[4].status = true;
            this.setState({ todayTimeSlots: newTimeSlots, selectFutureDateError: false  });
          } else if (timeNewwHrs >= 18 ){
            // const newTimeSlots = [...this.state.todayTimeSlots];
            // newTimeSlots[0].status = false;
            // newTimeSlots[1].status = false;
            // newTimeSlots[2].status = false;
            // newTimeSlots[3].status = false;
            // newTimeSlots[4].status = false;
            // this.setState({ todayTimeSlots: newTimeSlots });
            this.setState({
              selectFutureDateError: true
            })
          } 
      }

    handleServiceType = (type) => {
        console.log("type", type);
        this.setState({
            whichServiceType: type
        })
        if(type === 0){
            this.updatingTodaysTiminggggg();

            this.setState({
                todaysDate: new Date(),
                todayServiceActive : true,
                futureServiceActive: false,
                bookingFinalPrice: this.state.taskDetailsPrev.rush_hr_price
            })
        } else if (type === 1){
            this.setState({
                todaysDate: addDays(new Date, 1),
                todayServiceActive : false,
                futureServiceActive: true,
                bookingFinalPrice: this.state.taskDetailsPrev.price
            })
        }
    }

    renderFutureTimeslots = () => {
        return(
            <div style={{
                // padding: 20,
                width: '100%', 
                marginTop: 20
            }}>
            {/* <p>Future slots</p> */}
            {
                this.state.selectDateError 
                ? 
                <div>
                    <p>Please select a future date</p>
                </div>
                : 
                <div>
                    { this.state.selectTimeslotError 
                        ? <p style={{color: 'red', textAlign: 'center'}}>Please Select a Timeslot</p>
                        : null
                    }
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        alignItems: 'center',
                        paddingTop: 20
                    }}>
                        {this.state.futureTimeSlots.length > 0 &&
                        this.state.futureTimeSlots.map((timeSlot, index) => {
        
                        return (
                            <div
                                key={index}
                                disabled={!timeSlot.status}
                                onClick={() =>
                                    timeSlot.status && this.onTimeSlotSelected(timeSlot)
                                }
                                style={{
                                    backgroundColor: 
                                    this.state.time === timeSlot.start ||
                                    this.state.isTimeslotSelected === timeSlot.label
                                        ? '#0078ff'
                                        : !timeSlot.status
                                        ? 'grey'
                                        : '#fff',
                                    margin: 5,
                                    borderRadius: 35,
                                    border: '1px solid #0078ff',
                                    opacity: timeSlot.status ? 1 : 0.5,
                                }}
                                >
                                <p
                                    style={{
                                    color: this.state.time === timeSlot.start ||
                                    this.state.isTimeslotSelected === timeSlot.label
                                        ? '#fff'
                                        : '#0078ff',
        
                                    padding: 10,
                                    paddingBottom: 0
                                        // this.state.time === timeSlot.start ||
                                        // this.state.booked_time === timeSlot.label
                                        // ? store.getState().settings.colors.PRIMARY.HEX
                                        // : !timeSlot.status
                                        // ? store.getState().settings.colors.PRIMARY.HEX
                                        // : store.getState().settings.colors.SECONDARY.HEX,
                                    }}
                                    >
                                    {timeSlot.label}
                                </p>
                            </div>
                        );
                        })}
                    </div>
                </div>

            }

        </div>
        )
    }

    renderTodayTimeslots = () => {
        return(
            <div style={{
                // padding: 20,
                width: '100%',
                marginTop: 20
            }}>
            {/* <p>Today slots</p> */}
            {
                this.state.selectFutureDateError 
                ? 
                <div>
                    <p>Please select a date in the future</p>
                </div>
                :
                <div>
                    { this.state.selectTimeslotError 
                        ? <p style={{color: 'red', textAlign: 'center'}}>Please Select a Timeslot</p>
                        : null
                    }
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        alignItems: 'center',
                        paddingTop: 20
                    }}>
                        {this.state.todayTimeSlots.length > 0 &&
                        this.state.todayTimeSlots.map((timeSlot, index) => {
        
                        return (
                            <div
                                key={index}
                                disabled={!timeSlot.status}
                                onClick={() =>
                                    timeSlot.status && this.onTimeSlotSelected(timeSlot)
                                }
                                style={{
                                    backgroundColor: 
                                    this.state.time === timeSlot.start ||
                                    this.state.isTimeslotSelected === timeSlot.label
                                        ? '#0078ff'
                                        : !timeSlot.status
                                        ? '#bbb'
                                        : '#fff',
                                    margin: 5,
                                    borderRadius: 35,
                                    border: '1px solid #0078ff',
                                    opacity: timeSlot.status ? 1 : 0.5,
                                }}
                                >
                                <p
                                    style={{
                                    color: this.state.time === timeSlot.start ||
                                    this.state.isTimeslotSelected === timeSlot.label
                                        ? '#fff'
                                        : '#0078ff',
        
                                    padding: 10,
                                    paddingBottom: 0
                                    }}
                                    >
                                    {timeSlot.label}
                                </p>
                            </div>
                        );
                        })}
                    </div>
                </div>
            }

        </div>
        )
    }


    onTimeSlotSelected = (time) => {
        console.log("time selected", time);
        this.setState({
            selectTimeslotError: false,
            isTimeslotSelected: time.label,
            selectedTimeSlotLabel: time.label,
            timeNew: time.start,
        })
    }

    onDateSelected = (date)=> {
        console.log("DATE NEEW CLICKED VAL", date)
        let abDate = new Date().getDate()
        let abMonth = new Date().getMonth()
        let abYear = new Date().getFullYear()
        let abAll = `${abDate}/${abMonth}/${abYear}`

        let cdDate = new Date(date).getDate()
        let cdMonth = new Date(date).getMonth()
        let cdYear = new Date(date).getFullYear()
        let cdAll = `${cdDate}/${cdMonth}/${cdYear}`
        // console.log("abAll == cdAll",abAll == cdAll);

        // console.log("click1", new Date(date).getDate())
        // console.log("click2", opDate);
        // console.log("===", date === opDate);
        if(abAll == cdAll){
            this.setState({
                whichServiceType: 0
            })
        } else if(abAll !== cdAll){
            this.setState({
                whichServiceType: 1,
                selectFutureDateError: false
            })
        }

        // const event = new Date(date);
        let event;
        if(this.state.bookingPath =='edit'){
            event = new Date(this.state.bookingDateEdit)
        } else {
            event = new Date(date);
        }
        console.log("eevenntt",event);

        let formattedDate = event.toLocaleString().split(',')[0];
        console.log("formattedDate", formattedDate);
        this.setState({
            // todaysDate: formattedDate,
            todaysDate: date,
            selectDateError: false,
            originalCalendarDate: date
        })
    }

    // Wed Jun 28 2023 00:00:00 GMT+0530 (India Standard Time) -- first time
    // Tue Jun 20 2023 18:39:04 GMT+0530 (India Standard Time) -- after edit

    onContinuePressed = () => {
        console.log("----------isTimeslotSelected", this.state.isTimeslotSelected);
        let booking_infoData = {
            booking_value: this.state.taskDetailsPrev.quantity * this.state.bookingFinalPrice,
            booking_date: this.state.todaysDate,
            booking_slot: this.state.selectedTimeSlotLabel,
            booking_quantity: this.state.taskDetailsPrev.quantity,
            task_id: this.state.taskDetailsPrev.key,
            service_id: this.state.taskDetailsPrev.category_id,
            category_id: this.state.taskDetailsPrev.mastercategory_id,
            booking_type: this.state.taskDetailsPrev.booking_type,
            service_type: this.state.taskDetailsPrev.service_type,
            task_name: this.state.taskDetailsPrev.full_name.service,
            service_name: this.state.taskDetailsPrev.full_name.category,
            category_name: this.state.taskDetailsPrev.full_name.master_category,
            originalCalendarDate: this.state.originalCalendarDate
          };
        this.props.history.push('/user/additional_info', {taskBooking: this.state.taskDetailsPrev, bookingInfoData : booking_infoData})
    }
      

    render() {
    let allEvents = [];

        // console.log("TASK DETAILS ON BOOKING SCHEDULE", this.state.taskDetailsPrev);
        var well={
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Booking Schedule' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            <div>
                                <div style={{
                                    display: 'flex'
                                }}>
                                    <div>
                                        <p style={{
                                            fontSize: 25,
                                            textAlign: 'center',
                                            marginBottom: 10
                                        }}>When do you want the service?</p>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            // backgroundColor: 'red',
                                            marginTop: 45
                                        }}>
                                            <div 
                                                onClick={()=> this.handleServiceType(0)}
                                                style={{
                                                    backgroundColor: this.state.todayServiceActive ? '#0078ff': 'white',
                                                    display: 'flex',
                                                    // flexDirection: 'column',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '20px 25px',
                                                    // marginRight: 20,
                                                    boxShadow: "2px 1px 5px #ddd",
                                                    borderRadius: 10,
                                                    width: '80%'
                                                }}
                                            >
                                                <span style={{color: this.state.todayServiceActive ? 'white': '#0078ff',  }}>
                                                    <AccessTime style={{fontSize: 65}} />
                                                </span>
                                                <div>
                                                    <p style={{
                                                        fontSize: 20, 
                                                        color: this.state.todayServiceActive ? 'white': '#0078ff',
                                                        marginTop: 10
                                                    }}>Today</p>
                                                    <p style={{
                                                        fontSize: 25,
                                                        marginBottom: 0,
                                                        color: this.state.todayServiceActive ? 'white': '#0078ff'
                                                    }}>${this.state.taskDetailsPrev.rush_hr_price}</p>
                                                </div>
                                            </div>
                                            <div
                                                onClick={()=> this.handleServiceType(1)}
                                                style={{
                                                    // backgroundColor: '#fff',
                                                    backgroundColor: this.state.futureServiceActive ? '#0078ff': 'white',
                                                    display: 'flex',
                                                    // flexDirection: 'column',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '20px 25px',
                                                    // marginRight: 20,
                                                    boxShadow: "2px 1px 5px #ddd",
                                                    borderRadius: 10,
                                                    width: '80%',
                                                    marginTop: 35
                                                }}
                                            >
                                                <span style={{  }}>
                                                    <CalendarTodayTwoTone style={{
                                                        fontSize: 65, 
                                                        color: this.state.futureServiceActive ? 'white': '#0078ff'
                                                    }}/>
                                                </span>
                                                <div>
                                                    <p style={{
                                                        fontSize: 20, 
                                                        color: this.state.futureServiceActive ? 'white': '#0078ff',
                                                        marginTop: 10
                                                    }}>Future</p>
                                                    <p style={{
                                                        fontSize: 25, 
                                                        marginBottom: 0,
                                                        color: this.state.futureServiceActive ? 'white': '#0078ff'
                                                    }}>${this.state.taskDetailsPrev.price}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{
                                        marginLeft: 20
                                    }}>
                                        <p style={{
                                            fontSize: 25,
                                            // marginTop: 40,
                                            textAlign: 'center'
                                        }}>Select a Date & Time</p>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            // backgroundColor: '#ccc',
                                            // boxShadow: "2px 1px 5px #ddd",
                                            marginTop: 45
                                        }}>
                                        <Calendar 
                                            style={{ height: "100vh", width: '50%', color: "red", background: "#fff" }} 
                                            onClickDay={(value)=> this.state.whichServiceType === 1 && this.onDateSelected(value)}
                                            minDate={new Date()}
                                            maxDate={ this.state.whichServiceType === 1 ? this.addDays(new Date, 60) : new Date()}
                                            defaultValue={this.state.bookingPath =='edit' ? this.state.bookingDateEdit : this.state.todaysDate}
                                            // tileDisabled={({date}) => date.getDate() === new Date()}
                                            tileDisabled={({date}) => this.state.whichServiceType === 1 ? date.getDate()=== date1 : null}
                                        />
                                        {
                                            this.state.whichServiceType === 1
                                            ? this.renderFutureTimeslots()
                                            : this.renderTodayTimeslots()
                                        }

                                    </div>
                                    </div>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    marginTop: 70
                                }}>
                                    <p 
                                    // onClick={ this.onContinuePressed }
                                    onClick={()=> {
                                        this.state.selectFutureDateError 
                                        ? NotificationManager.warning('Please select a Future date', '') 
                                        : this.state.selectTimeslotError 
                                        ? NotificationManager.warning('Please select a Timeslot', '')  
                                        : this.onContinuePressed()
                                    }}
                                    style={{
                                        backgroundColor: '#0078ff',
                                        padding: '7px 20px',
                                        color: '#fff',
                                        borderRadius: 5,
                                        fontSize: 17,
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        marginRight: 25
                                    }}>Continue</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedComponent = compose(connect(mapStateToProps, actions));
// export default composedProfile(withRouter(BookingScheduleScreenNew));

const ColoredDateCellWrapper = ({ children }) =>
  React.cloneElement(React.Children.only(children), {
    style: {
      backgroundColor: "lightblue",
    },
  });

export default composedComponent(BookingScheduleScreenNew);


// WEBPACK FOOTER //
// ./src/views/User/BookingScheduleScreenNew.jsx